'use client';
import { Section } from '@react-stately/collections';
import e__default from 'react';

const ListboxSection = (e)=>e__default.createElement(Section, e);
Object.assign(ListboxSection, Section), ListboxSection.displayName = 'ListboxSection';

export { ListboxSection };
